import { apiRequest } from './api';

export const cronService = {
  /**
   * Executa um cron manualmente pela chave da configuração
   * Chaves suportadas: lastExecCronLembretes, lastExecCronAtualizarFaturas, lastExecCronAniversario,
   * lastExecCronBackup, lastExecCronTransmissaoNfcom
   */
  async execute(chave: string): Promise<{ success: boolean; message?: string }> {
    const response = await apiRequest.post<{ success: boolean; message?: string }>(
      `/cron/execute/${encodeURIComponent(chave)}`
    );
    return response;
  },
};
